import { useCallback, useState } from 'react';

interface UseAttachmentViewerResult {
  openIndex: number | null;
  isOpen: boolean;
  open: (index: number) => void;
  close: () => void;
  next: (total: number) => void;
  prev: (total: number) => void;
}

export function useAttachmentViewer(): UseAttachmentViewerResult {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const open = useCallback((index: number) => {
    setOpenIndex(index);
  }, []);

  const close = useCallback(() => {
    setOpenIndex(null);
  }, []);

  const next = useCallback((total: number) => {
    if (total <= 0) {
      return;
    }
    setOpenIndex((prev) => {
      if (prev === null) {
        return 0;
      }
      return (prev + 1) % total;
    });
  }, []);

  const prev = useCallback((total: number) => {
    if (total <= 0) {
      return;
    }
    setOpenIndex((current) => {
      if (current === null) {
        return total - 1;
      }
      return (current - 1 + total) % total;
    });
  }, []);

  return {
    openIndex,
    isOpen: openIndex !== null,
    open,
    close,
    next,
    prev,
  };
}
